import { createSlice } from "@reduxjs/toolkit";
import { login, logout, getUser } from "../actions/user";

const initialState: any = {
  basicUserInfo: null,
  getUserStatus: "idle",
  userProfileData: undefined,
  status: "idle",
  error: null,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action: any) => {
        state.status = "ready";
        localStorage.setItem("@auth:token", action.payload.data.access_token);
        state.token = action.payload.data.access_token;
      })
      .addCase(logout.fulfilled, (state, action: any) => {
        state.status = "idle";
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "error";
        state.error = "Falha ao autenticar.";
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getUser.pending, (state) => {
        state.getUserStatus = "loading";
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state, action: any) => {
        state.getUserStatus = "ready";
        state.basicUserInfo = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.getUserStatus = "error";
        state.error = action.error.message ?? "Falha ao carregar os grupos.";
      });
  },
});

export default userSlice.reducer;
